import React, { useState, useRef } from 'react';
import Formsy from 'formsy-react';
import { observer } from 'mobx-react'

import { createStyles, makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

import DateTimeInput from '../../components/forms/inputs/DateTimeInput';
import SelectInput from '../../components/forms/inputs/SelectInput';
import SubmitButtonInput from '../../components/forms/inputs/SubmitButtonInput';
import TextfieldInput from '../../components/forms/inputs/TextfieldInput';

const useStyles = makeStyles((theme) => createStyles({
  formContainer: {
  },
  formItem: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
}));

function EditRoomForm({ room }) {
  const [validForm, setValidForm] = useState(false);
  const [loading, setLoading] = useState(false);

  const form = useRef(null);

  const submitForm = (model) => {
    setLoading(true);
    return room && room.partialUpdate(model).then(() => {
      setLoading(false);
      form.current.reset(room);
    });
  }

  const classes = useStyles();

  return (
    <Formsy
      ref={ form }
      onValidSubmit={ submitForm }
      onValid={ () => setValidForm(true) }
      onInvalid={ () => setValidForm(false) }
    >
      <Grid className={ classes.formContainer } container alignContent="flex-start" alignItems="center">
        <Grid className={ classes.formItem } item sm={12}>
          <TextfieldInput
            value={ (room || {}).human_name || '' }
            name="human_name"
            label="Room Name"
            required
          />
        </Grid>
        <Grid className={ classes.formItem } item sm={12}>
          <SelectInput
            value={ (room || {}).status || '' }
            name="status"
            label="Room Status"
            items={ new Map(
              [
                ["stable", "Stable"],
                ["maturing", "Maturing"],
                ["mature", "Mature"],
                ["open", "Open"],
                ["", "None"]
              ])
            }
          />
        </Grid>
        <Grid className={ classes.formItem } item sm={12}>
          <TextfieldInput
            value={ (room || {}).notes || '' }
            name="notes"
            label="Notes"
            elementProps={{
              multiline: true,
            }}
          />
        </Grid>
        <Grid className={ classes.formItem } item sm={12}>
          <TextfieldInput
            value={ (room || {}).customer_notes || '' }
            name="customer_notes"
            label="Customer Notes"
            elementProps={{
              multiline: true,
            }}
          />
        </Grid>
        <Grid className={ classes.formItem } item sm={12}>
          <DateTimeInput
            name="close_timestamp"
            label="Room Closed"
            value={ (room || {}).close_timestamp }
            elementProps={{
              format: "MM/DD/YYYY hh:mm:ss",
            }}
          />
        </Grid>
        <Grid className={ classes.formItem } item sm={12}>
          <DateTimeInput
            name="open_timestamp"
            label="Room Opened"
            value={ (room || {}).open_timestamp }
            elementProps={{
              format: "MM/DD/YYYY hh:mm:ss",
            }}
          />
        </Grid>
        <Grid className={ classes.formItem } item sm={12}>
          <DateTimeInput
            name="predicted_ready_timestamp"
            label="Predicted Ready"
            value={ (room || {}).predicted_ready_timestamp }
            elementProps={{
              format: "MM/DD/YYYY hh:mm:ss",
            }}
          />
        </Grid>
        <Grid className={ classes.formItem }  item sm={12}>
          <SubmitButtonInput
            name="submit"
            contents="Save"
            validForm={ validForm }
            loading={ loading }
            elementProps={{
              "color": "primary",
            }}
          />
        </Grid>
      </Grid>
    </Formsy>
  );
}

export default observer(EditRoomForm);

